import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import UsersControl from '../../pages/InsigthFactory/Users';
import * as paths from '../../routes/paths';
import { Context } from '../../context/Contex';
import { getMods, getUsers, postMods } from '../../services/insightUsersService';
import { swalMessages, permitsList } from '../../constants';
import linkCards from '../../constants/linkCards';

const initialForm = {
  id_unidad: '',
  id_usuario: '',
  valueInput: null,
};
const UsersControlContainer = () => {
  const [mods, setMods] = useState([]);
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [openForm, setOpenForm] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const history = useHistory();
  const { permisos } = useContext(Context);
  const permitValue = permisos[permitsList.FABRICA_INSIGHTS];

  const optionUsers = users?.map((user) => ({
    label: `${user.nombre} ${user.apellido} (${user.correo})`,
    value: user.id,
  }));

  const onClickReturn = () => {
    history.push(paths.INSIGHT_FACTORY);
  };

  const fetchMods = async () => {
    const { success, data } = await getMods();
    if (success) {
      setMods(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const fetchUsers = async () => {
    const { success, data } = await getUsers();
    if (success) {
      setUsers(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const onOpenForm = (index) => {
    const moderator = mods[index];
    const valueInput = optionUsers
      .filter((user) => user.value === moderator.id_usuario)
      .pop();
    setForm({ ...form, ...moderator, valueInput });
    setOpenForm(true);
  };

  const onCloseForm = () => {
    setForm(initialForm);
    setOpenForm(false);
  };

  const onChange = (value, type) => {
    if (type === 'input') {
      setInputValue(value);
    } else {
      setForm({ ...form, valueInput: value });
    }
  };

  const onSubmitForm = async (event) => {
    event.preventDefault();
    const { success } = await postMods({
      id_unidad: form.id_unidad,
      id_usuario: form.valueInput.value,
    });
    if (success) {
      swal(swalMessages.SUCCESFUL_UPDATE);
      fetchMods();
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const chooseUrl = (unitId) => {
    const imageUrl = linkCards
      .filter((link) => link.id === Number(unitId))
      .pop();
    return imageUrl.link;
  };

  const withoutPermit = (permit) => {
    if (permit < 5) {
      history.push(paths.INSIGHT_FACTORY);
    } else {
      return null;
    }
  };

  useEffect(() => {
    withoutPermit(permitValue);
    fetchMods();
    fetchUsers();
  }, []);

  return (
    <UsersControl
      form={form}
      mods={mods}
      users={optionUsers}
      openForm={openForm}
      onChange={onChange}
      chooseUrl={chooseUrl}
      onOpenForm={onOpenForm}
      inputValue={inputValue}
      onCloseForm={onCloseForm}
      onSubmitForm={onSubmitForm}
      onClickReturn={onClickReturn}
    />
  );
};

export default UsersControlContainer;
